import { apiClient } from "@/lib/api-client"
import type { IntentionDetail, IntentionFiltersState, IntentionRitualsResponse } from "../types"

export async function getIntention(slug: string): Promise<IntentionDetail> {
  const response = await apiClient.get<{
    success: boolean
    data: IntentionDetail
    message: string
  }>(`/api/intentions/${slug}`)
  return response.data.data
}

export async function getIntentionRituals(
  slug: string,
  filters: IntentionFiltersState,
  page: number,
  limit = 8,
): Promise<IntentionRitualsResponse> {
  const params = new URLSearchParams()
  params.set("page", String(page))
  params.set("limit", String(limit))

  if (filters.search) params.set("search", filters.search)
  if (filters.sort !== "newest") params.set("sort", filters.sort)
  if (filters.price !== "all") params.set("price", filters.price)
  if (filters.format !== "all") params.set("format", filters.format)
  if (filters.duration !== "all") params.set("duration", filters.duration)

  const response = await apiClient.get<{
    success: boolean
    data: IntentionRitualsResponse
    message: string
  }>(`/api/intentions/${slug}/rituals?${params.toString()}`)
  return response.data.data
}

export async function toggleIntention(
  intentionId: string,
): Promise<{ action: "added" | "removed" }> {
  const response = await apiClient.post<{
    success: boolean
    data: { action: "added" | "removed" }
    message: string
  }>(`/api/intentions/${intentionId}/toggle`)
  return response.data.data
}
